import { put, select, takeEvery } from 'redux-saga/effects';
import { Selectors as RouterSelectors, Types as RouterTypes } from 'router';
import { Types as AuthTypes } from 'services/authentication';

export interface GetWatchOptions {
  urlParam: string;
  query?: { [key: string]: string };
}

type RequestAction = (id: string, query: { [key: string]: string }) => any;

function* triggerRequest(requestGet: RequestAction, options: GetWatchOptions, signIn: boolean) {
  const id = yield select(RouterSelectors.getParam, options.urlParam);
  if (signIn) {
    if (!!id) {
      yield put(requestGet(id, options.query));
    }
    return;
  }

  const lastid = sessionStorage.getItem(`last-get-${options.urlParam}`) || 'noKey';
  if (!!id && id !== lastid) {
    sessionStorage.setItem(`last-get-${options.urlParam}`, id);
    yield put(requestGet(id, options.query));
  }
}

export function newGetWatchSaga(requestGet: RequestAction, options: GetWatchOptions) {
  return function*() {
    yield takeEvery(AuthTypes.POPULATE_USER, () => triggerRequest(requestGet, options, true));
    yield takeEvery(RouterTypes.LOCATION_CHANGED, () => triggerRequest(requestGet, options, false));
  };
}
